import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Amendment } from '../../../types/amendment/Amendment'
import { amendmentKeys } from '../queries/amendmentQueryKeys'
import { updateAmendment } from '../service/amendmentService'

export const useUpdateAmendment = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'amendment', 'update'],
    mutationFn: (amendment: Amendment) => updateAmendment(companyId, amendment),
    onSuccess: () => {
      message.success(t('messages:updateSuccess', 'Updated successfully'))
      queryClient.invalidateQueries({ queryKey: amendmentKeys.all })
      // Note: Financial statements invalidation is handled by global mutation observer
    },
    onError: () => {
      message.error(t('messages:updateError', 'Failed to update'))
    }
  })
}
